module.exports = __webpack_public_path__ + "static/media/something-went-wrong-icon.509541c8.svg";